import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import {
  CHARITY_VERIFICATION_STATUS_VARIANTS,
  getCharityVerificationBadgeKey,
} from '../../../lib/stripeConnect'

const TRANSLATION_PREFIX = 'charities.dashboard.stripe.status'

export default function CharityVerificationBadge({ stripeStatus }) {
  const { t } = useTranslation()
  const badgeKey = getCharityVerificationBadgeKey(stripeStatus)
  const badgeVariant =
    CHARITY_VERIFICATION_STATUS_VARIANTS[badgeKey] || 'secondary'

  return (
    <span className={`badge bg-${badgeVariant}`}>
      {t(`${TRANSLATION_PREFIX}.${badgeKey}`)}
    </span>
  )
}

CharityVerificationBadge.propTypes = {
  stripeStatus: PropTypes.object,
}
